export function isSupportConsole(): boolean {
  return _isSupportConsole(import.meta.env.VITE_SITE_PROFILE);
}
function _isSupportConsole(supportConsole: string): boolean {
  return ["support-console"].includes(supportConsole);
}
